module.exports = __webpack_public_path__ + "media/images/pages/bg_digest-6e2314ec798d5f6e2fe0f11cadccef38.png";